import React from 'react';
import _ from 'lodash';
import { Collapse } from '@blueprintjs/core';

import { ColumnGroupHeader } from './ColumnGroupHeader';
import { WorkersColumn } from './WorkersColumn';
import { OpenShiftsSideColumn } from './OpenShiftsSideColumn';
import { EmptySideColumn } from './EmptySideColumn';
import { IRosterShift, IRosterWorker, IRosterWorkerWithShifts } from '../../types';

interface WorkersSideColumnProps {
  unassignedShifts: IRosterShift[][];
  assignedShifts: IRosterWorkerWithShifts[];
  workers: IRosterWorker[];
  isWorkersOpen: boolean;
  setWorkersOpen: any;
}

export function WorkersSideColumn({
  unassignedShifts = [],
  assignedShifts = [],

  workers = [],
  setWorkersOpen = () => {},
  isWorkersOpen = true,
}: WorkersSideColumnProps) {
  const hasOpenShifts = !_.isEmpty(unassignedShifts);
  const hasWorkers = !_.isEmpty(workers);

  return (
    <div>
      <ColumnGroupHeader text='Team members' onClick={() => setWorkersOpen(!isWorkersOpen)} isOpen={isWorkersOpen} />
      <Collapse isOpen={isWorkersOpen} keepChildrenMounted={false}>
        <div className='flex-column'>
          {!hasWorkers && !hasOpenShifts && <EmptySideColumn type='worker' />}
          {hasOpenShifts && <OpenShiftsSideColumn unassignedShifts={unassignedShifts} />}
          {_.map(workers, (worker, idx) => (
            <WorkersColumn
              key={idx}
              worker={worker}
              // totalDuration={0}
              assignedShifts={assignedShifts}
            />
          ))}
        </div>
      </Collapse>
    </div>
  );
}
